export default {"src":"/_next/static/image/public/images/surveyprogress.5b8075aade95b728b118e95bda77f3ff.svg","height":6,"width":200};